import * as React from "react";
import Button from "@mui/material/Button";
import { useState } from "react";
import { Avatar } from "@mui/material";
import bookmark from "../../assets/img/3.png";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "../../assets/css/Noti.css";
import { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Link } from "react-router-dom";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { ToastContainer, toast } from "react-toastify";
import { FaEdit, FaTrash } from "react-icons/fa";
import preloadimg from "../../assets/img/preloader1.gif";
import SideDrawer from "../layout/SideDrawer";
import AppButton from "../layout/AppButton";
import { useBookmark } from "../../hooks/useBookmark";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const chipStyle = {
  background: "#eee",
  paddingLeft: "5px",
  paddingRight: "5px",
  color: "#283978",
  fontSize: "12px",
};

function formatSavedAt(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * The slice a bookmark holds, as "Column: value" labels.
 *
 * Page filters and slicer selections are stored separately but read the same to
 * a person, so both are flattened into one list, keyed by column so a column
 * filtered at both levels is only shown once.
 */
function summariseSavedFilters(filterJson, slicerJson) {
  const byColumn = new Map();

  const add = (filter) => {
    const column = filter?.target?.column;
    const values = filter?.values;
    if (!column || !Array.isArray(values) || values.length === 0) return;
    const shown = values.slice(0, 3).map(String).join(", ");
    byColumn.set(column, `${column}: ${shown}${values.length > 3 ? "…" : ""}`);
  };

  try {
    if (filterJson) JSON.parse(filterJson).forEach(add);
  } catch {
    // A malformed record should not take the list down.
  }

  try {
    if (slicerJson) {
      JSON.parse(slicerJson).forEach((slicer) => (slicer?.state?.filters || []).forEach(add));
    }
  } catch {
    // As above.
  }

  return [...byColumn.values()];
}

export default function Bookmark() {
  // const notify = () => toast("Wow so easy!");
  const { fetchBookmarks, deleteBookmark: deleteBookmarkApi, updateBookmarkTitle } = useBookmark();
  const [isLoading, setisLoading] = useState(false);
  const [openNoti, setopenNoti] = useState(false);
  const [open, setOpen] = useState(false);
  const [saveReports, setSaveReports] = useState([]);
  const [LoadingUpdate, setLoadingUpdate] = useState(false);
  const [reportIdtext, setreportIdtext] = useState();
  const [reportTitletext, setreportTitletext] = useState("");
  const [Saving, setSaving] = useState(false);

  useEffect(() => {
    GetSaveReports();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const GetSaveReports = async () => {
    try {
      const data = await fetchBookmarks();
      setSaveReports(data);
      setisLoading(false);
    } catch {
      setSaveReports(null);
      setisLoading(false);
    }
  };

  const removeBookmark = (id, page, title) => {
    setSaving(true);
    deleteBookmarkApi(id, page, title)
      .then(() => {
        GetSaveReports();
        setSaving(false);
        toast.success(`${decodeURIComponent(title)} Deleted Successfully`, {
          // Set to 15sec
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 6000,
        });
      })
      .catch((error) => {
        setSaving(false);
        alert("Error deleting resource:", error);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const UpdateTitle = () => {
    if (reportTitletext === "") return false;

    setLoadingUpdate(true);

    updateBookmarkTitle(reportIdtext, reportTitletext)
      .then(() => {
        GetSaveReports();
        setLoadingUpdate(false);
        setOpen(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadingUpdate(false);
        alert("Error");
      });
  };

  const openEditBox = (id, title) => {
    setreportIdtext(id);
    setreportTitletext(title);
    setOpen(!open);
  };

  const openBookmarks = () => {
    GetSaveReports();
    setopenNoti(true);
  };

  return (
    <div id="BookmarkDrawer">
      <Button id="NotiIconsnew" onClick={openBookmarks}>
        <BookmarkAddedIcon />
      </Button>

      <SideDrawer
        open={openNoti}
        onClose={() => setopenNoti(false)}
        title="All Bookmarks"
        width={420}
      >
        {isLoading ? (
          <div style={{ width: "auto", height: "500px" }} className="loadingBookmark">
            Getting your bookmark, please wait...
          </div>
        ) : (
          <div>
            {saveReports.length === 0 && (
              <div style={{ height: "100%" }} className="noBookmark">
                <div>
                  <img width={200} src={bookmark} alt="bookmark" />
                </div>
                <div style={{ display: "grid", gridGap: "6px" }}>
                  <span
                    style={{
                      fontSize: "20px",
                      color: "gray",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    Add Bookmark
                  </span>
                  <span
                    style={{
                      width: "80%",
                      display: "block",
                      margin: "auto",
                      color: "gray",
                      fontSize: "14px",
                    }}
                  >
                    {" "}
                    Don't forget to bookmark the report you like most so
                    that you can find those easily over here
                  </span>
                </div>
              </div>
            )}

            {saveReports.length !== 0 && (
              <div className="all-bookmark">
                {saveReports.map((saved, index) => {
                  const savedAt = formatSavedAt(saved.createdAt);
                  const savedFilters = summariseSavedFilters(saved.filterJson, saved.slicerJson);
                  return (
                    <div
                      className="bookmark-items"
                      key={index}
                      style={{
                        padding: "15px",
                        borderBottom: "1px solid #eee",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          alignContent: "center",
                          gridGap: "10px",
                        }}
                      >
                        {/* <Avatar>{saved.title.charAt(0)}</Avatar> */}
                        <div style={{ display: "grid", gap: "5px", width: "100%" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              width: "100%",
                              gap: "10px",
                            }}
                          >
                            <Link
                              style={{
                                textDecoration: "none",
                                background: "none",
                              }}
                              className="bookmarkListItmes"
                              // The id travels in the URL so the saved view is
                              // replayed on a refresh too, not just on arrival.
                              to={`/reports/${parseInt(
                                saved.reportId
                              )}/view?ReportSection=${saved.pagename}&groupId=${saved.userGroupId}&bookmarkId=${saved.id}`}
                            >
                              <span style={{ fontWeight: 700 }}>{saved.title}</span>
                            </Link>
                          </div>

                          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "2px", marginTop: "5px" }}>
                            {saved.groupName && (
                              <span style={chipStyle}>{saved.groupName}</span>
                            )}
                            {saved.reportName && (
                              <span style={chipStyle}>{saved.reportName}</span>
                            )}
                          </div>

                          {savedFilters.length > 0 && (
                            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                              {savedFilters.map((label) => (
                                <span
                                  key={label}
                                  style={{
                                    background: "#eef2ff",
                                    border: "1px solid #e0e7ff",
                                    borderRadius: "4px",
                                    padding: "1px 6px",
                                    color: "#3730a3",
                                    fontSize: "11px",
                                  }}
                                >
                                  {label}
                                </span>
                              ))}
                            </div>
                          )}

                          <div style={{ display: "flex", gap: "20px", marginTop: "10px", alignItems: "center", justifyContent: "space-between" }}>
                            {savedAt && (
                              <span style={{ color: "#888", fontSize: "12px", whiteSpace: "nowrap", opacity: 0.6 }}>{savedAt}</span>
                            )}

                            <div style={{ display: "flex", gap: "20px" }}>
                              <FaEdit
                                style={{
                                  color: "#253978",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) =>
                                  openEditBox(saved.id, saved.title)
                                }
                              />

                              <FaTrash
                                onClick={(e) =>
                                  removeBookmark(
                                    parseInt(saved.reportId),
                                    saved.pagename,
                                    saved.title
                                  )
                                }
                                style={{
                                  color: "#dc3545",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

            {Saving && (
              <div
                style={{
                  position: "fixed",
                  background: "rgba(0,0,0,0.8)",
                  width: "100%",
                  height: "100%",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  zIndex: "99999",
                  justifyItems: "center",
                  alignContent: "center",
                }}
              >
                <img width={200} src={preloadimg} alt="Loading" />
                <span>Deleting your bookmark...</span>
              </div>
            )}
          </div>
        )}
      </SideDrawer>

      <ToastContainer />

      <Dialog open={open} onClose={(e) => setOpen(!open)}>
        <DialogTitle
          style={{ background: "var(--app-button-color, #a70e13)", color: "#fff", fontWeight: "500" }}
        >
          Rename Your Bookmark Title
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Avatar>N</Avatar>
              <div style={{ display: "grid" }}>
                <span> {userInfo?.given_name}</span>
                <span style={{ fontSize: "14px" }}>{userInfo?.email}</span>
              </div>
            </div>
          </DialogContentText> */}
          <TextareaAutosize
            value={reportTitletext}
            onChange={(e) => setreportTitletext(e.target.value)}
            style={{
              width: "100%",
              height: "auto",
              minHeight: "50px",
              border: "2px solid #eee",
              padding: "10px",
              borderRadius: "6px",
              marginTop: "24px",
              minWidth: "400px",
              maxWidth: "400px",
              resize: "none",
            }}
            className="popup-input"
            placeholder="Rename your Bookmark"
          />
        </DialogContent>
        <DialogActions id="postCommentActions">
          <AppButton variant="secondary" onClick={handleClose}>
            Cancel
          </AppButton>
          <AppButton variant="fill" disabled={LoadingUpdate} onClick={UpdateTitle}>
            {LoadingUpdate ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ paddingLeft: "10px" }}>Updating...</span>
              </>
            ) : (
              "Rename"
            )}
          </AppButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
